export default {
    requirements: {
        low: {
            id: 'low',
            name: 'Low',
            totalFootage: 100,
            staffing: 0.125,
            staffingCode: "sm",
            equipment: [],
            software: [],
            otherItems: []
        },

        medium: {
            id: 'medium',
            name: 'Medium',
            totalFootage: 100,
            staffing:0.25,
            staffingCode: "sm",
            equipment: [],
            software: [],
            otherItems: []
        },

        high: {
            id: 'high',
            name: 'High',
            totalFootage: 100,
            staffing: 0.375,
            staffingCode: "sm",
            equipment: [],
            software: [],
            otherItems: []
        },
    },

    ratingDetails: [
        {
            id: 'level',
            type: 'enum',
            required: false,
            component: 'PulloutQuestionMultiSwitchList',
            default: 0,
            label: "Level of Need:",
            options: [
                {
                    id: "none",
                    label: "None",
                    value: 0
                },

                {
                    id: "low",
                    label: "Low",
                    description: "up to 4 jobs per month 48/yr",
                    value: 1
                },
                {
                    id: "medium",
                    label: "Medium",
                    description: "up to 8 jobs per month, 96/yr",
                    value: 2
                },
                {
                    id: "high",
                    label: "High",
                    description: "up to 12 jobs per month 144/yr",
                    value: 3
                }
            ]
        }

    ]
}
